module.exports = __webpack_public_path__ + "img/hz_18.a8eba19f.jpg";